import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { UserAvatar } from "../../elements/ElementsIndex";
import styled from "styled-components";

const DivContainer = styled.div`
  min-height: ${(props) => props.divStyle.divMinHeight || "8vh"};
  display: flex;
  vertical-align: middle;
  padding-top: ${(props) => props.divStyle.paddingTop || "0px"};
  padding-bottom: ${(props) => props.divStyle.paddingBottom || "0px"};
  padding-left: ${(props) => props.divStyle.paddingLeft || "0px"};
  padding-right: ${(props) => props.divStyle.paddingRight || "0px"};
  flex-direction: row;
  justify-content: ${(props) => props.divStyle.justifyContent || "flex-start"};
  flex-grow: 1;
`;

export const Modal = (props) => {
  return (
    <div>
      <Dialog open={props.status} onClose={props.handleClose}>
        <DivContainer
          divStyle={{
            divMinHeight: "10vh",
          }}
        >
          <DialogTitle>{props.title}</DialogTitle>
          <DivContainer
            divStyle={{
              paddingTop: "12px",
              paddingRight: "16px",
              justifyContent: "flex-end",
            }}
          >
            {props.imageUrl && <UserAvatar src={props.imageUrl} />}
          </DivContainer>
        </DivContainer>
        <DialogContent>{props.children}</DialogContent>
        <DialogActions>
          <Button
            onClick={
              props.onFirstActionClick
                ? props.onFirstActionClick
                : props.handleClose
            }
          >
            {props.firstActionDesc}
          </Button>
          <Button
            onClick={
              props.onSecondActionClick
                ? props.onSecondActionClick
                : props.handleClose
            }
          >
            {props.secondActionDesc}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
